import { h, FunctionComponent, ComponentChildren, Fragment } from "preact"; /** @jsx h */
import { clsx } from 'clsx';
import { Authored, IAuthoredProps } from "./Authored";
import { useEffect, useRef } from "preact/hooks";
import { ContentItem } from "../ContentItem";


export type IItemProps = {
    title: string;
    abstract?: string;
    image?: string;
    children?: ComponentChildren;
    linkTo: string; // e.g. ./index.html
    mode?: 'promoted' | 'standard' | 'compact' | 'ordered';
} & IAuthoredProps;

const PostImage = ({src, alt}) => {
    return <img src={src} alt={alt} />;
}

/**
 * The outer frame of the post item. When ordered: it is a `<li>`, otherwise a `<div>`.
 */
const Frame = ({mode, children, ...frameProps}) => {
    if (mode === 'ordered') {
        return <li {...frameProps}>{children}</li>;
    } else {
        return <div {...frameProps} className={clsx(
            mode === 'promoted' && 'card border-0 mb-4 box-shadow h-xl-300',
            mode === 'standard' && 'mb-3 d-flex justify-content-between',
            mode === 'compact' && 'mb-3 d-flex align-items-center'
        )}>{children}</div>;
    }
}


export const Item = (props: IItemProps) => {


    return (
        (
            props.mode === 'promoted' && <div className="card border-0 mb-4 box-shadow h-xl-500 promoted">              
                <div style={{
                    backgroundImage: props.image ? `url(${props.image})` : "none",
                    height: "150px",
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "top center"
                }}>{
                    props.children
                }
                </div>               
                <div className="card-body px-0 pb-0 d-flex flex-column align-items-start">
                    <h2 className="h4 font-weight-bold">
                    <a href={props.linkTo}>
                        {props.title}
                    </a>
                    </h2>
                    { props.abstract && <ContentItem contentId={props.title} text={props.abstract} ptClassName="card-text" /> }
                        
                    <Authored {...props} />
                </div>
            </div>
        ) || (
            props.mode === 'standard' && <div className="mb-3 d-flex justify-content-between">
                <div className="pr-3">
                    <h2 className="mb-1 h4 font-weight-bold">
                    <a href={ props.linkTo /*+ "?emtkn=l6j5e9ma49296b6x7dk2nnq4" */ }>{ props.title }</a>
                    </h2>
                    { props.abstract && <ContentItem contentId={props.title} text={props.abstract} ptClassName="card-text" /> }
                    <Authored {...props} />
                </div>
                {props.image && <img height="120" src={props.image}></img>}
            </div>
        )  || (
            props.mode === 'compact' && <div className="mb-3 d-flex align-items-center">
                { props.image && <img height="80" src={props.image}></img> }
                <div className="pl-3">
                    <h2 className="mb-2 h6 font-weight-bold">
                    <a href={ props.linkTo }>{ props.title }</a>
                    </h2>
                    { props.abstract && <ContentItem contentId={props.title} text={props.abstract} ptClassName="card-text text-muted small" /> }
                    
                    <Authored {...props} />
                </div>
            </div>
        ) || (
            props.mode === 'ordered' && <li>
                <span>
                    <h6 className="font-weight-bold">
                        <a href={props.linkTo} >{props.title}</a>
                    </h6>
                    <Authored {...props} />
                </span>
            </li>
        ) || <div>  

        </div>
    )


}
